/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts from 'highcharts';
import { merge, cloneDeep } from 'lodash';
import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  Button,
  CircularProgress
} from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { barChartBase } from './utils/barChartBase';

const scrollableMinHeight = shippedItemsQuantities => {
  if (shippedItemsQuantities.length >= 100) {
    return 4000;
  }
  return shippedItemsQuantities.length * 40;
};

const ShippedItemsChartDialog = ({
  shippedItemsQuantities,
  loadingShippedItemsQuantities,
  open,
  handleClose
}) => {
  const totalShipped = shippedItemsQuantities.reduce(
    (a, b) => +a + +b.quantity,
    0
  );

  const override = {
    chart: {
      scrollablePlotArea: {
        minHeight: scrollableMinHeight(shippedItemsQuantities),
        opacity: 0.6
      },
      marginRight: 30
    },
    xAxis: {
      categories: shippedItemsQuantities.map(s => s.description),
      pointPadding: 30
    },
    yAxis: {
      stackLabels: {
        enabled: false
      },
      maxPadding: 0.1
    },
    plotOptions: {
      series: {
        dataLabels: {
          inside: false,
          // eslint-disable-next-line
          formatter: function() {
            return `${this.total} | ${(
              (this.total * 100) /
              totalShipped
            ).toFixed(2)} %`;
          }
        }
      }
    },
    series: [
      {
        name: 'Article',
        data: shippedItemsQuantities
          .slice(0, 100)
          .map(s => [s.description, s.quantity])
      }
    ]
  };
  const options = merge(cloneDeep(barChartBase), override);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Box pt={6} pl={10} pr={10}>
        <Box display="flex" alignItems="baseline" mb={4}>
          <Box fontSize={21} color="#001C56">
            Articles expédiés
          </Box>
        </Box>
      </Box>
      {loadingShippedItemsQuantities ? (
        <Box display="flex" justifyContent="center" p={20}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
      <Divider />
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  shippedItemsQuantities: state.dashboard.shippedItemsQuantities,
  loadingShippedItemsQuantities: state.dashboard.loadingShippedItemsQuantities
});

ShippedItemsChartDialog.propTypes = {
  shippedItemsQuantities: PropTypes.array,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  loadingShippedItemsQuantities: PropTypes.bool
};

export default connect(mapStateToProps)(ShippedItemsChartDialog);
